module.exports = __webpack_public_path__ + "img/th_th.6286947e.png";